var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imLineUp"
  }, [_c('im-top'), _vm._v(" "), _c('div', {
    staticClass: "text text_top"
  }, [_vm._v("当前所有客服已经达到上限，请耐心等候")]), _vm._v(" "), _c('div', {
    staticClass: "text text_bottom"
  }, [_vm._v("我们很快就来接待您，谢谢")]), _vm._v(" "), _c('div', {
    staticClass: "imgwrap"
  }, [_c('img', {
    staticClass: "errImg",
    attrs: {
      "src": _vm.imgUrl + 'im-acc.png',
      "alt": "无客服"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text innerText"
  }, [_vm._v("当前等待人数")]), _vm._v(" "), _c('span', {
    staticClass: "text innerNum"
  }, [_vm._v(_vm._s(_vm.currentPosition))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.giveUpInLine
    }
  }, [_vm._v("放弃排队")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0fc85ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/im/imLineUp.vue
// module id = Lp0V
// module chunks = 1